import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  IconButton,
  List,
  ListItemButton,
  type PaperProps,
  Popover,
  Stack,
  type StackProps,
  Typography,
} from "@mui/material";
import type { ReactElement } from "react";
import { cloneElement } from "react";
import { useIconsGroup } from "./logics";

export interface IIcon {
  component: ReactElement;
  label: string;
  callBack?: () => void;
  hidden?: boolean;
}

export interface IIconsGroup {
  icons: IIcon[];
  limit: number;
  slotProps?: { stackProps?: StackProps; paperProps?: PaperProps };
}

export const IconsGroup = ({ icons, limit = 2, slotProps }: IIconsGroup) => {
  const { displayedIcons, hiddenIcons, anchorEl, handleOpen, handleClose } = useIconsGroup(icons, limit);

  return (
    <Stack
      direction="row"
      {...slotProps?.stackProps}
      sx={{
        alignItems: "center",
        gap: 1,
      }}
    >
      {displayedIcons.map((icon) => {
        const elem = cloneElement(icon.component, { onClick: icon.callBack, key: icon.label });
        return elem;
      })}
      {hiddenIcons.length !== 0 && (
        <>
          <IconButton onClick={handleOpen} size="small">
            <MoreVertIcon color="primary" />
          </IconButton>
          <Popover
            open={!!anchorEl}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            onClose={handleClose}
            slotProps={{
              paper: {
                square: true,
                ...slotProps?.paperProps,
              },
            }}
          >
            <Stack component={List}>
              {hiddenIcons.map((icon) => (
                <ListItemButton
                  onClick={() => {
                    if (icon.callBack) {
                      icon.callBack();
                    }
                    handleClose();
                  }}
                  key={icon.label}
                >
                  <Typography variant="body1">{icon.label}</Typography>
                </ListItemButton>
              ))}
            </Stack>
          </Popover>
        </>
      )}
    </Stack>
  );
};
